import { Component, OnInit } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { ContractOutgoingMail, ContractsOutgoingMailResourceType } from '../../_types/contract-outgoing-mail';
import { ContractOutgoingMailsService } from '../../_services/contracts-outgoing-mails.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom } from 'rxjs';
import { MailAccountsService } from 'src/app/modules/comunications/_services/mail-account.service';
import { LoginService } from 'src/app/modules/login/login.service';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { ConfirmationService, MessageService } from 'primeng/api';

@Component({
    selector: 'app-outgoing-mail-detail',
    templateUrl: './outgoing-mail-detail.component.html',
    styleUrls: ['./outgoing-mail-detail.component.css'],
    standalone: false
})
export class OutgoingMailDetailComponent implements OnInit {

  public contractOutgoingMailFormGroup!: RxFormGroup;

  public contractOutgoingMail: ContractOutgoingMail = new ContractOutgoingMail();
  public types: any[] = [];
  public mailAccounts: any[] = [];
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
public contractsOutgoingMailResourceType: any[] = [
    {name: 'Informe fotográfico', id: ContractsOutgoingMailResourceType.PhotoReport},
    {name: 'Factura ', id: ContractsOutgoingMailResourceType.Invoice},
    {name: 'Auto factura', id: ContractsOutgoingMailResourceType.IncomingInvoice},
    {name: 'Presupuestos', id: ContractsOutgoingMailResourceType.Budget},
    {name: 'Otros', id: ContractsOutgoingMailResourceType.Other},
  ];

  constructor(
    private contractOutgoingMailsService: ContractOutgoingMailsService,
    private config: DynamicDialogConfig,
    private mailAccountsService: MailAccountsService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private loginService: LoginService,
        private messageService: MessageService,
        private dynamicDialogRef: DynamicDialogRef,
        private confirmationService: ConfirmationService,
  ) { 
    this.contractOutgoingMailFormGroup = this.formBuilder.formGroup<ContractOutgoingMail>(this.contractOutgoingMail) as RxFormGroup;
  }

  ngOnInit() {
    if (this.config.data.contractOutgoingMailId) {
      this.loadContractOutgoingMail(this.config.data.contractOutgoingMailId);
    } else {
      this.contractOutgoingMail.contractId = this.config.data.contractId;
    }
    this.loadMailAccounts();
    this.allowWrite = this.loginService.hasPermission("COMPANIES.WRITE");
    this.allowDelete = this.loginService.hasPermission("COMPANIES.DELETE");
  }

  async loadContractOutgoingMail(id: any){
    this.contractOutgoingMail = await firstValueFrom(this.contractOutgoingMailsService.get(id));    
    this.contractOutgoingMailFormGroup.patchValue(this.contractOutgoingMail);

  }
  
  async loadMailAccounts() {
    let response = await firstValueFrom(this.mailAccountsService.all());
    this.mailAccounts = response.data;
  }
  

  async save(){
    let valid = this.formValidationService.validateForm(this.contractOutgoingMailFormGroup);
    if (valid) {
      this.contractOutgoingMail = Object.assign(this.contractOutgoingMail, this.contractOutgoingMailFormGroup.value);

      await this.contractOutgoingMailsService.save(this.contractOutgoingMail).subscribe({
        next: (data) => {
          this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Email guardado correctamente' });
          this.dynamicDialogRef.close();
        },
        error: (error) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error al guardar la especialidad' });
        }
      });
    } else {
      document.getElementById('form')?.classList.add('formInvalid');
    }
  }

  
  cancel(){
   this.dynamicDialogRef.close();
  }

  delete(){
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el email?",
      header: "Eliminar email",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.contractOutgoingMailsService.delete(this.contractOutgoingMail.id).subscribe({
          next: (data: any) => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Email eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      }
    });
  }
}
